// extracted by mini-css-extract-plugin
export default {"limitedWarranty":"limited-warranty-v2--limitedWarranty"};